module.exports = __webpack_public_path__ + "images/1.1791972770245.jpg";